import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 26 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.215, 0.61, 0.355, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p
    className={`text-xs font-semibold tracking-[0.28em] uppercase text-emerald-900/80 ${className}`}
  >
    {children}
  </p>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2
    className={`font-serif text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.12] font-semibold text-slate-950 ${className}`}
  >
    {children}
  </h2>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.95, delay, ease: [0.215, 0.61, 0.355, 1] }}
    >
      {children}
    </motion.span>
  </span>
);
